import React from 'react';
import { Building2, Wrench, Star, HelpCircle, List, Building } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const SchemaTypeSelector = ({ selectedType, onChange }) => {
  const schemaTypes = [
    {
      type: 'LocalBusiness',
      icon: Building2,
      title: 'LocalBusiness Schema',
      description: 'Sacramento County business information, hours, and location details',
      color: 'blue'
    },
    {
      type: 'Service',
      icon: Wrench,
      title: 'Service Schema',
      description: 'Bail bond services with pricing and area served information',
      color: 'green'
    },
    {
      type: 'Review',
      icon: Star,
      title: 'Review Schema',
      description: 'Client testimonials and ratings for enhanced search results',
      color: 'yellow'
    },
    {
      type: 'FAQ',
      icon: HelpCircle,
      title: 'FAQ Schema',
      description: 'Frequently asked questions about bail bonds process',
      color: 'purple',
      disabled: true
    },
    {
      type: 'BreadcrumbList',
      icon: List,
      title: 'Breadcrumb Schema',
      description: 'Site navigation structure for better search appearance',
      color: 'pink',
      disabled: true
    },
    {
      type: 'Organization',
      icon: Building,
      title: 'Organization Schema',
      description: 'Company structure, leadership, and contact information',
      color: 'indigo',
      disabled: true
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-bold text-gray-900 mb-4">Select Schema Type</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {schemaTypes?.map((schema) => {
          const Icon = schema?.icon;
          const isSelected = selectedType === schema?.type;
          const isDisabled = schema?.disabled;

          return (
            <button
              key={schema?.type}
              onClick={() => !isDisabled && onChange(schema?.type)}
              disabled={isDisabled}
              className={`p-4 rounded-lg border-2 text-left transition-all ${
                isDisabled
                  ? 'border-gray-200 bg-gray-50 opacity-50 cursor-not-allowed'
                  : isSelected
                  ? `border-${schema?.color}-500 bg-${schema?.color}-50`
                  : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-10 h-10 rounded-lg bg-${schema?.color}-100 flex items-center justify-center flex-shrink-0 ${
                  isSelected ? `bg-${schema?.color}-200` : ''
                }`}>
                  <Icon className={`w-5 h-5 text-${schema?.color}-600`} />
                </div>
                
                <div className="flex-1 min-w-0">
                  <h3 className={`font-semibold mb-1 ${isSelected ? 'text-gray-900' : 'text-gray-700'}`}>
                    {schema?.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-snug">
                    {schema?.description}
                  </p>
                  {isDisabled && (
                    <span className="inline-block mt-2 px-2 py-1 bg-gray-200 text-gray-600 text-xs font-medium rounded">
                      Coming Soon
                    </span>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SchemaTypeSelector;